module.exports = __webpack_public_path__ + "img/dubg.1fd45226.png";